import { GradientVariant, gradientValues } from '@front/common/src/utils/colors';

export const getGradient = (variant: GradientVariant = 'default') =>
  `linear-gradient(${gradientValues.angle}deg, ${gradientValues.colors[variant].join(', ')})`;

export const borderGradient100 = `linear-gradient(white, white) padding-box, ${getGradient()} border-box`;
export const borderGradient50 = `linear-gradient(white, white) padding-box, ${getGradient('gradient50')} border-box`;
